export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="bg-background-100 rounded-lg border border-background-200/60 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
              <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 bg-accent-500/10 rounded-full border border-accent-500/20 mb-4">
                移动观影
              </span>
              <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 tracking-wide mb-3">
                随时随地 · 高清追剧
              </h2>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-md lg:max-w-none">
                黄瓜影院移动端适配完美，在手机和平板上同样享受高清画质流畅播放体验。无需下载安装，打开浏览器即可观看，观影进度多端自动同步。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-3 px-6 py-3 bg-background-50 border border-background-200/60 rounded-lg cursor-pointer hover:border-primary-500/20 transition-all duration-300">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-android-line text-lg text-foreground-600"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500">Android 端</p>
                    <p className="text-sm font-semibold text-foreground-800">浏览器访问</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 px-6 py-3 bg-background-50 border border-background-200/60 rounded-lg cursor-pointer hover:border-primary-500/20 transition-all duration-300">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-apple-line text-lg text-foreground-600"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500">iOS 端</p>
                    <p className="text-sm font-semibold text-foreground-800">浏览器访问</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-1 w-full max-w-sm lg:max-w-md p-6 md:p-8 lg:p-0 lg:pr-14 flex justify-center">
              <div className="relative w-48 md:w-56 aspect-[9/19] rounded-2xl overflow-hidden bg-background-200 border-4 border-background-300">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20showing%20modern%20streaming%20app%20interface%20with%20movie%20thumbnails%20in%20dark%20theme%2C%20warm%20coral%20and%20amber%20accent%20colors%2C%20clean%20UI%20design%2C%20cinematic%20posters%20grid%2C%20professional%20entertainment%20app%20aesthetic%2C%20sleek%20minimal%20layout&width=600&height=1200&seq=app-mobile-screen&orientation=portrait"
                  alt="黄瓜影院移动端界面"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}